<template>
  <div class="tw-bg-bgMain tw-w-full tw-bg-white tw-py-24">
    <div
      class="tab-view-container tw-w-full tw-flex tw-flex-col"
      :class="{ 'animate-slide-up': isVisible }"
    >
      <span
        class="tw-w-full tw-text-center tw-text-4xl tw-font-bold tw-text-textMain tw-mb-4"
        v-html="$t('首页解决方案标题')"
      ></span>
      <span
        class="tw-w-full tw-text-center tw-text-sm tw-text-textDisabled tw-mb-10"
        >{{ $t("覆盖多领域需求，整合技术与服务驱动业务高效落地与持续增长") }}</span
      >

      <div class="home-section-inner">
          <div class="tw-flex tw-w-full tw-overflow-hidden">
            <div class="tw-flex-1 tw-overflow-hidden tw-flex tw-flex-col">
              <div class="card-container">
                <div
                  class="card"
                  v-for="(item, index) in tabsList"
                  :key="index"
                >
                  <img :src="item.mainImg" :alt="item.name" />
                  <div class="card-content">
                    <div class="tw-flex tw-flex-col title tw-text-white">
                      <span
                        class="tw-h-14 tw-text-xl fontstylewrapmore-2 tw-font-medium"
                        >{{ item.name }}</span
                      >
                      <span
                        class="fontstylewrapmore-3 tw-mt-3 tw-text-sm title-info"
                        >{{ item.intro }}</span
                      >
                      <span
                        class="fontstylewrapmore-3 tw-mt-3 tw-text-sm title-desc tw-leading-relaxed"
                        >{{ item.desc }}</span
                      >
                    </div>

                    <div class="card-c-btn">
                      <span
                        @click.stop="handleClickRoute(item)"
                        class="tw-py-2 tw-w-full tw-text-center tw-rounded-sm tw-cursor-pointer tw-flex tw-items-center tw-justify-center tw-gap-2"
                      >
                        {{ $t("了解更多") }}
                        <img
                          src="@/assets/home/arrow_right.png"
                          alt=""
                          class="btn-icon"
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tw-mt-10 tw-text-center">
                {{ $t("找不到合适的解决方案？") }}
                <span
                  style="color: #4077F8FF; cursor: pointer;"
                  @click="handleClickRoute"
                >
                  <span>{{ $t("立即咨询") }}</span>
                  <b-icon icon="chevron-right" class="tw-ml-1"></b-icon>
                </span>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import { solutionsApi } from "@/api/modules/home";
import BigImg from "@/components/skeleton/bigImg.vue";
export default {
  components: {
    BigImg,
  },
  data() {
    return {
      tabsList: [],
      isLoading: true,
      isVisible: false,
      observer: null,
    };
  },
  mounted() {
    const info = JSON.parse(localStorage.getItem("indexInfo"));
    if (info) {
      this.getList();
    }
    this.$nextTick(() => {
      setTimeout(() => {
        this.initIntersectionObserver();
      }, 500);
    });
  },
  methods: {
    initIntersectionObserver() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.isVisible) {
              this.isVisible = true;
              // 动画只执行一次，所以可以断开观察器
              this.observer.disconnect();
            }
          });
        },
        {
          threshold: 0, // 当组件10%可见时触发
        }
      );

      this.observer.observe(this.$el);
    },
    getList() {
      solutionsApi({
        pageIndex: 1,
        pageSize: 5,
      }).then((res) => {
        this.tabsList = res.data.list || [];
      });
    },
    handleClickRoute(row) {
      if (this.$screen.md) {
        window.kuaizhichat();
      } else {
        window.kuaizhiMobileChat();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.tab-view-container {
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease-out;
}

.tab-view-container.animate-slide-up {
  opacity: 1;
  transform: translateY(0);
}

.flex-1 {
  flex: 1;
}

.flex-start {
  display: flex;
  justify-content: flex-start;
}

.solution-container {
  display: flex;
}

.solution-item {
  display: flex;
  height: 400px;
  margin: 10px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  position: relative;

  &:hover {
    cursor: pointer;
    transform: translateY(-3px);
  }
}

.solution-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.solution-content {
  position: absolute;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: #fff;
  height: 100%;
}

.solution-title {
  font-size: 20px;
  margin-bottom: 10px;
}

.solution-desc {
  font-size: 14px;
  margin-bottom: 10px;
}

.solution-link {
  color: #007bff;
  text-decoration: none;
}

.consult-button {
  display: inline-block;
  padding: 6px 12px;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid #fff;
  color: white;
  text-decoration: none;
}

.check-btn {
  width: 172px;
  height: 43px;
  line-height: 43px;
  margin: 0 auto;
  border-radius: 5px;
  border: 1px solid #ebebeb;
  cursor: pointer;

  &:hover {
    background: #007bff;
    color: white;
    border: 1px solid #007bff;
  }
}

.card-container {
  display: flex;
  gap: 20px;
  width: 100%;
}

.card {
  height: 460px;
  overflow: hidden;
  position: relative;
  transition: all 0.5s ease;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  flex: 2;
  border-radius: 16px;
  border: none;
}

.card:first-child {
  flex: 4;

  .card-c-btn {
    width: 100%;
    display: flex;
  }

  .card-content {
    background: linear-gradient( 180deg, #5776F4 0%, rgba(43,89,249,0.8) 50%, rgba(0,59,254,0) 100%);
    justify-content: space-between;
    .title {
      color: #fff;
      .title-info {
        display: none;
        color: #fff
      }

      .title-desc {
        display: block;
        color: #fff
      }
    }
  }
}

.card-container:hover .card:first-child:not(:hover) {
  flex: 2;

  .card-c-btn {
    display: none;
  }

  .card-content {
    background: transparent;
    .title {
      color: #111111FF;
      .title-info {
        color: #666666FF;
        display: block;
      }

      .title-desc {
        display: none;
        color: #666666FF;
      }
    }
  }
}

.card:not(:first-child) {
  .card-content {
    .title {
      .title-info {
        display: block;
      }

      .title-desc {
        display: none;
      }
    }
  }
}

.card:hover {
  flex: 4;

  .card-c-btn {
    width: 100%;
    display: flex;
  }

  .card-content {
    background: linear-gradient( 180deg, #5776F4 0%, rgba(43,89,249,0.8) 50%, rgba(0,59,254,0) 100%);
    justify-content: space-between;
    .title {
      color: #fff;
      .title-info {
        display: none;
        color: #fff;
      }

      .title-desc {
        display: block;
        color: #fff;
      }
    }
  }
}

.card-container:hover .card:not(:hover) {
  flex: 2;

  .card-c-btn {
    display: none;
  }

  .card-content {
    .title {
      .title-info {
        display: block;
      }

      .title-desc {
        display: none;
      }
    }
  }
}

.card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.2;
}

.card-content {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: start;
  width: 100%;
  height: 100%;
  padding: 20px;
  border-radius: 10px;
  overflow: hidden;
  .title {
    color: #111111FF;
  }
  .title-info {
    color: #666666FF;
  }
  .title-desc {
    color: #666666FF;
  }
}

.card-content h3 {
  margin: 0 0 10px 0;
  font-size: 16px;
}

.card-content p {
  margin: 0;
  font-size: 14px;
  opacity: 0.5;
}

.card-c-btn {
  display: none;
  width: 100%;
  font-size: 13px;
  transition: all 0.5s ease;
  cursor: pointer;
  background: #FFFFFF;
  border-radius: 8px;
  border: 1px solid #4077F8;
  
  span {
    font-weight: 600;
    font-size: 16px;
    color: #4077F8;
  }
.btn-icon {
  display: block;
  width: 14px;
  height: 14px;
  vertical-align: middle;
  opacity: 1;
}
}
</style>
